import { Injectable } from "@angular/core";
import { Book } from "./book.model";
import { AngularFireDatabase } from "@angular/fire/database";
import { AngularFirestore } from "@angular/fire/firestore";
import * as data from "./biletlingo.json";
@Injectable({
  providedIn: "root",
})
export class BookService {
  listBooks!: Book[];
  constructor() // private afDb: AngularFireDatabase // private firestore: AngularFirestore // private firestore: AngularFirestore,
  {}

  getBooks() {
    // return this.afDb.list<Book>("onlinebooks").valueChanges();
    return data;
  }
}
